import React from 'react';

const AchievementMovementIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="4" fill="#626BFE" />
      <path
        d="M7.85982 8.43018H4.81982V18.6702H7.85982V8.43018Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4696 15.96L16.5696 17.65C17.0196 18.03 17.2796 18.56 17.2796 19.11C17.2796 19.5 17.1596 19.9 16.8996 20.23C16.7296 20.44 16.5496 20.61 16.3296 20.72C16.1196 20.84 15.8896 20.91 15.6696 20.95C15.2996 21 14.9396 20.95 14.5996 20.78L9.53963 18.14C9.12963 17.93 8.67963 17.81 8.20963 17.8H7.86963V10.04H15.5096L19.6696 11.61"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.83 17.6701C27.83 21.1701 24.99 24.0101 21.49 24.0101C19.17 24.0101 17.13 22.7501 16.03 20.8901V20.8501C16.12 20.8201 16.23 20.7801 16.34 20.7101C16.56 20.6001 16.74 20.4401 16.91 20.2201C17.17 19.8901 17.29 19.4901 17.29 19.1001C17.29 18.5501 17.04 18.0101 16.58 17.6401L15.27 16.5901V16.5301C15.69 14.1801 17.42 12.2701 19.68 11.5901C20.26 11.4201 20.86 11.3301 21.49 11.3301C24.99 11.3301 27.83 14.1701 27.83 17.6701Z"
        fill="white"
      />
      <path d="M18.9399 15.23H24.3799" stroke="#626BFE" strokeWidth="1.2" strokeLinejoin="round" />
      <path d="M19 16.9702H24.44" stroke="#626BFE" strokeWidth="1.2" strokeLinejoin="round" />
      <path
        d="M20.74 15.23C21.74 15.23 22.53 16.04 22.53 17.02C22.53 18 21.72 18.81 20.74 18.81C20.48 18.81 20.22 18.75 20 18.65L22.68 21.33"
        stroke="#626BFE"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AchievementMovementIcon;
